__turbopack_context__.v({
  "actionLink": "Mfqe8W_actionLink",
  "companions": "Mfqe8W_companions",
  "details": "Mfqe8W_details",
  "direction": "Mfqe8W_direction",
  "directionCopy": "Mfqe8W_directionCopy",
  "example": "Mfqe8W_example",
  "guideLink": "Mfqe8W_guideLink",
  "guideLinks": "Mfqe8W_guideLinks",
  "intro": "Mfqe8W_intro",
  "stepNumber": "Mfqe8W_stepNumber",
  "steps": "Mfqe8W_steps",
  "stepsHeading": "Mfqe8W_stepsHeading",
  "stepsSection": "Mfqe8W_stepsSection",
});
